module.exports = __webpack_public_path__ + "e2dd4d7474578e6501c6889ff22eb6a0.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=410!./images/head/TWS_gang.jpg
// module id = 483
// module chunks = 0